// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const contentApi = {
  getFeed(advertiserId, feedId) {
    return client.get(`/content/a/${advertiserId}/feeds/${feedId}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  exportArticlesAsCSV(payload) {
    let endpoint = `/content/feeds/${payload.feedId}/csv`;
    if (payload.hasOwnProperty('contentItemIds')) endpoint += `?contentItemIds=${payload.contentItemIds}`;
    return client.get(endpoint)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  fetchLanguages() {
    return client.get('/content/languages')
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchLanguages(payload) {
    const requestPayload = {
      languageId: payload.languageId,
      filters: payload.filters,
    };
    if (payload.hasOwnProperty('contentItemIds')) requestPayload.contentItemIds = payload.contentItemIds;
    return client.patch(`/content/a/${payload.advertiserId}/feeds/${payload.feedId}/content-items`, requestPayload)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  },
  newGetFeedContent(payload) {
    const {
      feedId, filtersQuery, offset,
    } = payload;
    let url = `/content/feeds/${feedId}?${filtersQuery}`;
    if (offset) url += `&offset=${offset}`;
    return client.get(url)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getFeedContentItems(payload) {
    const {
      feedId, filtersQuery,
    } = payload;
    const url = `/content/feeds/${feedId}/content-items?${filtersQuery}`;
    return client.get(url)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getFeedContent(feedId, page, pageSize, creativeId) {
    return client.get(`/content/feeds/${feedId}?page=${page}&pageSize=${pageSize}&creativeId=${creativeId}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getAllFeedContent(feedId, query, creativeId) {
    const url = `/content/feeds/${feedId}?${query}&creativeId=${creativeId}`;
    return client.get(url)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getFilteredFeedContent(feedId, page, pageSize, query, creativeId) {
    const url = `/content/feeds/${feedId}?page=${page}&pageSize=${pageSize}${query}&creativeId=${creativeId}`;
    return client.get(url)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getFeedContentById(feedId, contentId, pageSize, creativeId) {
    return client.get(`/content/feeds/${feedId}?contentItemId=${contentId}&pageSize=${pageSize}&creativeId=${creativeId}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  sendContentForScraping(payload) {
    return client.post(`/content-scraping/a/${payload.advertisersId}/feeds/${payload.feedId}/content-scrapes?campaignId=${payload.campaignId}`, { urls: payload.urls })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  sendFileContentForScraping(payload) {
    const formData = new FormData();
    formData.append('multipartFile', payload.file);

    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    const contentScrapeOptionalParam = payload.contentScrapeId ? `&contentScrapeId=${payload.contentScrapeId}` : '';
    return client.post(`/content-scraping/a/${payload.advertiserId}/feeds/${payload.feedId}/video-scrapes?campaignId=${payload.campaignId}&landingUrl=${payload.landingUrl}${contentScrapeOptionalParam}`, formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchScrapedContent(payload) {
    return client.patch(`/content-scraping/a/${payload.advertisersId}/feeds/${payload.feedId}/content-scrapes/${payload.contentScrapeId}?campaignId=${payload.campaignId}`,
      {
        urls: payload.urls,
        emailOnCompletion: payload.emailOnCompletion,
      })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  uploadURLsSpreadsheet(payload) {
    const formData = new FormData();
    formData.append('file', payload.file);

    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return client.post(`/content-scraping/a/${payload.advertiserId}/feeds/${payload.feedId}/upload?campaignId=${payload.campaignId}`, formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchScrapedContentItem(payload) {
    return client.patch(`/content-scraping/a/${payload.advertisersId}/feeds/${payload.feedId}/content-scrapes/${payload.contentScrapeId}/content-scrape-items/${payload.contentScrapeItemId}`, { ...payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getScrapedContent(payload) {
    return client.get(`/content-scraping/a/${payload.advertisersId}/feeds/${payload.feedId}/content-scrapes`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getAllCreativeDisplayProperties(campaignId, payload) {
    const { creativeId, uuids } = payload;
    const uuidList = Array.isArray(uuids) && uuids.length > 0 ? uuids.join() : uuids;
    let url = `/creative/campaigns/${campaignId}/creatives/${creativeId}/display-properties`;
    if (uuids) url += `?contentItemUuids=${uuidList}`;

    return client.get(url)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCustomProperties() {
    return client.get('/content/content-item-property-types')
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentItem(payload, id) {
    return client.get(`/content/a/${payload.advertisersId}/feeds/${payload.feedId}/content-items/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getAllContentItemsByFeedId(feedId) {
    return client.get(`/content/content-items?feedIds=${feedId}&states=DRAFT,PAUSED,PUBLISHED,SCHEDULED`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentItems(payload) {
    return client.get(`/content/content-items?feedIds=${payload.feedIds}&states=PAUSED,PUBLISHED,SCHEDULED`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  setContentItemState(payload) {
    const requestPayload = {
      action: payload.action,
    };
    if (payload.hasOwnProperty('contentItemIds')) {
      requestPayload.contentItemIds = payload.contentItemIds;
    } else {
      requestPayload.filters = payload.filters;
    }
    return client.post(`content/a/${payload.advertiserId}/feeds/${payload.feedId}/publish`, requestPayload)
      .then((response) => response.status)
      .catch((error) => {
        throw error;
      });
  },
  setContentItemSchedule(payload) {
    const requestPayload = {
      schedule: payload.schedule,
    };
    if (payload.hasOwnProperty('contentItemIds')) {
      requestPayload.contentItemIds = payload.contentItemIds;
    } else {
      requestPayload.filters = payload.filters;
    }
    return client.post(`content/a/${payload.advertiserId}/feeds/${payload.feedId}/schedule`, requestPayload)
      .then((response) => response.status)
      .catch((error) => {
        throw error;
      });
  },
  deleteContentScrapes(payload) {
    const requestPayload = {};
    if (payload.hasOwnProperty('ids')) requestPayload.data = { failedContentScrapeIds: payload.ids };
    return client.delete(`/content-scraping/a/${payload.advertiserId}/feeds/${payload.feedId}/content-scrapes/${payload.contentScrapeId}/content-scrape-items`, requestPayload)
      .then((response) => response.status)
      .catch((error) => {
        throw error;
      });
  },
  deleteContentItems(payload) {
    const requestPayload = {};
    if (payload.hasOwnProperty('ids')) {
      requestPayload.data = { contentItemIds: payload.ids, filters: payload.filters };
    } else {
      requestPayload.data = { filters: payload.filters };
    }
    return client.delete(`/content/a/${payload.advertiserId}/feeds/${payload.feedId}/content-items?campaignId=${payload.campaignId}`, requestPayload)
      .then((response) => response.status)
      .catch((error) => {
        throw error;
      });
  },
  updateContentItem(payload) {
    return client.patch(`/content/a/${payload.advertisersId}/feeds/${payload.feedId}/content-items/${payload.id}`, { ...payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteContentItem(payload) {
    return client.delete(`/content/feeds/${payload.feedId}/content-items/${payload.id}?campaignId=${payload.campaignId}`, { ...payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  updateContentDisplayCopy(campaignId, payload) {
    return client.patch(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/creative-display-properties`, {
      contentItemUuid: payload.id,
      displayProperties: payload.body,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  fetchCreativeTemplates(payload) {
    let endpoint = '/creative-template/creative-templates?';
    if (payload?.campaignId) endpoint += `campaignId=${payload?.campaignId}`;
    if (payload?.templateGroupId) endpoint += `&templateGroupId=${payload?.templateGroupId}`;

    return client.get(endpoint)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCreativeTemplateById(id) {
    return client.get(`/creative-template/creative-templates/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCreativeTemplateByCampaignIds(campaignIds) {
    return client.get(`/creative-template/creative-templates?campaignIds=${campaignIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCreatives(campaignId) {
    return client.get(`/creative/campaigns/${campaignId}/creatives`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCreativesAsSharee(campaignIds) {
    return client.get(`/creative/creatives?campaignIds=${campaignIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  postCreatives(campaignId, payload) {
    return client.post(`/creative/campaigns/${campaignId}/creatives`, payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  postCreativesWithType(campaignId, payload) {
    return client.post(`/creative/campaigns/${campaignId}/${payload.creativeType}/creatives`, { sizes: payload.sizes })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  putCreatives(campaignId, payload) {
    return client.put(`/creative/campaigns/${campaignId}/creatives`, payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  putCreativesWithType(campaignId, payload) {
    return client.put(`/creative/campaigns/${campaignId}/${payload.creativeType}/creatives`, { sizes: payload.sizes })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchCreative(campaignId, payload) {
    return client.patch(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}`, { properties: payload.properties })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCreativeContentStates(payload) {
    return client.get(`/creative/creatives/${payload.creativeId}/display-properties`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchCreativeContentStates(payload) {
    return client.patch(`/creative/campaigns/${payload.campaignId}/creatives/${payload.creativeId}/creative-display-properties`, payload.updatedItem)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  },
  uploadCreativeDisplayImage(campaignId, payload) {
    const { formData } = payload;
    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/mixed',
      },
    };
    return client.post(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/creative-display-properties/image`, formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  swapCreativeDisplayImage(campaignId, payload) {
    return client.put(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/creative-display-properties/image`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteCreativeDisplayImage(campaignId, payload) {
    return client.delete(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/creative-display-properties/image?contentItemUuid=${payload.contentItemUuid}&imageType=${payload.imageType}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  uploadLogoImage(campaignId, payload) {
    const { formData } = payload;
    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return client.post(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/upload-file`, formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteLogoImage(campaignId, payload) {
    return client.delete(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/file`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteCreativeProperties(campaignId, payload) {
    return client.delete(`/creative/campaigns/${campaignId}/creatives/${payload.creativeId}/properties`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentComments(payload) {
    return client.get(`/share/showcases/${payload.campaignId}/comments?creativeId=${payload.creativeId}&contentUuid=${payload.contentId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentCommentsCount(payload) {
    return client.get(`/share/showcases/${payload.campaignId}/comments/counts?creativeId=${payload.creativeId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  postContentComment(payload) {
    return client.post(`/share/showcases/${payload.campaignId}/comments`, { ...payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  postSharedContentItem(payload) {
    return client.post(`/share/showcases/${payload.campaignId}/content-items/${payload.contentItemUUID}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteSharedContentItem(payload) {
    return client.delete(`/share/showcases/${payload.campaignId}/content-items/${payload.contentItemUUID}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  postSharedContent(payload) {
    return client.post(`/share/showcases/${payload.campaignId}/content-items/`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  postSharedContentOnlyState(payload) {
    return client.post(`/share/showcases/${payload.campaignId}/content-items?states=${payload.states}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteSharedContent(payload) {
    return client.delete(`/share/showcases/${payload.campaignId}/content-items/`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getSharedContentItems(campaignId) {
    return client.get(`/share/showcases/${campaignId}/content-items/shared`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getSharedCount(campaignId) {
    return client.get(`/share/showcases/${campaignId}/content-items/shared/counts`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getStates() {
    return client.get('/content/content-item-states')
      .then((response) => response);
  },
};
export default contentApi;
